import { template as template_c38a4d985d79420bb185f8b735594e86 } from "@ember/template-compiler";
import NavBarMap from 'eflex/util/nav-bar-map';
import Link from 'eflex/components/link';
import { service } from '@ember/service';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { t } from 'ember-intl';
import { fn, concat } from '@ember/helper';
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { on } from '@ember/modifier';
import { and, or } from 'ember-truth-helpers';
import BsTooltip from 'eflex/components/bs-tooltip';
import { isPresent, isBlank } from '@ember/utils';
import { replaceAll, compact } from 'ramda-adjunct';
import InputsLiveSearch from 'eflex/components/inputs/search-live';
import { map } from 'ramda';
import { intoArray } from '@eflexsystems/ramda-helpers';
const getCanNav = (item, licensing)=>{
    if (licensing.noProductsLicensed) {
        return item.key === 'settings';
    }
    if (item.lic != null) {
        return licensing.license?.[`${item.lic}Enabled`] ?? false;
    } else {
        return true;
    }
};
class NavItem extends Component {
    // eslint-disable-next-line ember/no-tracked-properties-from-args
    @tracked
    expanded = this.args.isExpanded;
    @service
    router;
    @service
    licensing;
    toggleExpanded = (hasChildren)=>{
        if (!hasChildren) {
            return;
        }
        this.expanded = !this.expanded;
    };
    static{
        template_c38a4d985d79420bb185f8b735594e86(`
    {{#let
      (t (concat 'navigation.' @item.label))
      (isPresent @item.children)
    as |label hasChildren|}}
      <li
        class='
          {{if @item.key (replaceAll '.' '-' @item.key)}}
          {{if hasChildren 'has-children'}}
          {{if (and hasChildren this.expanded) 'expanded'}}
        '
      >
        <Link
          class="d-flex align-items-center text-decoration-none fs-4 rounded"
          @route={{unless hasChildren @item.key}}
          @query={{@item.query}}
          @href={{if hasChildren "#" (if @item.href @item.href)}}
          target={{if @item.href "_blank"}}
          rel={{if @item.href "noopener noreferrer"}}
          {{on 'click' (fn this.toggleExpanded hasChildren)}}
        >
          {{#if hasChildren}}
            <FaIcon @icon="caret-right" @prefix="fas" class="sub-menu-arrow me-2" />
          {{/if}}
          {{#if @navCompressed}}
            <BsTooltip @title={{label}} @placement='right' @triggerEvents="hover" />
          {{else}}
            <span class="nav-item-label">{{label}}</span>
          {{/if}}
        </Link>

        {{#if (and hasChildren this.expanded)}}
          <ul class="nav-children mb-2">
            {{#each @item.children as |child|}}
              {{#if (getCanNav child this.licensing)}}
                <NavItem
                  @item={{child}}
                  @navCompressed={{@navCompressed}}
                />
              {{/if}}
            {{/each}}
          </ul>
        {{/if}}
      </li>
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
const getIsExpanded = (item, router)=>{
    return item.children?.some((child)=>router.isActive(child.key)) ?? false;
};
export default class NavBar extends Component {
    @service
    router;
    @service
    currentUser;
    @service
    resizeListener;
    @service
    licensing;
    @service
    intl;
    @tracked
    searchTerm;
    @cached
    get filteredChildren() {
        const sortedChildren = NavBarMap;
        const searchTerm = this.searchTerm;
        if (isBlank(searchTerm)) {
            return sortedChildren.map((child)=>({
                    ...child,
                    isExpanded: false
                }));
        }
        const searchRegex = new RegExp(`${searchTerm}`, 'i');
        return intoArray(map((parent)=>{
            let isExpanded = false;
            if (searchRegex.test(this.intl.t(`navigation.${parent.label}`))) {
                isExpanded = true;
                return {
                    ...parent,
                    isExpanded
                };
            }
            const filteredChild = {
                ...parent
            };
            filteredChild.children = (Array.isArray(filteredChild.children) ? filteredChild.children : []).filter((_child)=>{
                if (searchRegex.test(this.intl.t(`navigation.${_child.label}`))) {
                    isExpanded = true;
                    return true;
                }
                return false;
            });
            if (filteredChild.children?.length > 0) {
                return {
                    ...filteredChild,
                    isExpanded
                };
            }
        }), compact)(sortedChildren);
    }
    constructor(){
        super(...arguments);
        this.router._router.setupRouter();
    }
    static{
        template_c38a4d985d79420bb185f8b735594e86(`
    <div
      class="
        nav-bar
        hidden-print
        h-100
        d-flex
        flex-column
        bg-white
        border-end
        border-gray-200"
      ...attributes
    >
      <div class="bg-white p-3">
        <img src="/images/epicor-logo-blue.png" width="100" class="menu-logo py-2 mb-3" />
        {{#if this.currentUser.user}}
          <InputsLiveSearch
            @inputClass="navbar-search"
            @searchValue={{this.searchTerm}}
            @onInput={{fn (mut this.searchTerm)}}
          />
        {{/if}}
      </div>
      <nav
        class="
          eflex-scroll
          flex-fill
          bg-white
          position-relative
          h-100
          px-3"
      >
        <ul class="top-links list-unstyled d-flex flex-column">
          {{#if this.currentUser.user}}
            {{#each this.filteredChildren as |nav|}}
              {{#if (getCanNav nav this.licensing)}}
                <NavItem
                  @item={{nav}}
                  @navCompressed={{this.resizeListener.navCompressed}}
                  @isExpanded={{or (getIsExpanded nav this.router) nav.isExpanded}}
                  @searchTerm={{@searchTerm}}
                />
              {{/if}}
            {{/each}}
          {{/if}}
        </ul>
      </nav>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
